module.exports = __webpack_public_path__ + "img/zlp.205511c7.png";